module.exports = __webpack_public_path__ + "static/media/icon_55.1e0356b5.svg";